import * as ActionTypes from './../constants';
import { baseUrl } from '../index';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

// import { getLocation, isIos } from './../../utils';
 

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_SUBMIT_TEST: 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null,
                userSelectedAnswers: action.userSelectedAnswers,
                response: null
            }
        case ActionTypes.RECEIVED_SUBMIT_TEST: 
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_SUBMIT_TEST: 
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_SUBMIT_TEST: 
            return { }
        default :  return state
    }

}




const dispatchRequestSubmitTest = userSelectedAnswers => ({
    type: ActionTypes.REQUEST_SUBMIT_TEST,
    userSelectedAnswers
})

const dispatchReceivedSubmitTest = res => ({
    type: ActionTypes.RECEIVED_SUBMIT_TEST,
    res
})

const dispatchErrorSubmitTest = err => ({
    type: ActionTypes.ERROR_SUBMIT_TEST,
    err
})

const dispatchClearSubmitTest = () => ({
    type: ActionTypes.CLEAR_SUBMIT_TEST
})

export const clearSubmitTestData = () =>  dispatchClearSubmitTest();

export const submitTest =  (isPlannedTest = false, isTestSeries = false, isMaterialTest) => async (dispatch, getState) => {
       
        let endPoint = isPlannedTest ? 'submit_planned_test' : isTestSeries ? 'submit_mock_test' : isMaterialTest ? 'submitMaterialTest' : 'submit_test'
        let location;

        // if(!isIos) {
        //     try {
        //         // location = await getLocation();            
        //         location = 0;            
        //     }catch (e) {
        //         console.log(e);
        //     }
        // }
  
        const state = getState(); 
        const testAllQuestions = state.testInfo && state.testInfo.test && state.testInfo.test;
        const answers = state.testInfo.selectedAnswers || [];
        const requestedTestId = state.testInfo && state.testInfo.requestedTestId && (state.testInfo.requestedTestId.test_id || state.testInfo.requestedTestId.mock_test_id || state.testInfo.requestedTestId.material_test_id);
        const testId = state.testInfo && state.testInfo.testId || null 
        const _testId = !isPlannedTest ? requestedTestId : isTestSeries ? requestedTestId : testId;
        const timeSpent = state?.testInfo?.timeSpent || {};

        let userSelectedAnswers = [];       
        if(testAllQuestions && testAllQuestions.length && (testId || requestedTestId)) {
            testAllQuestions.map(question => {
                let isAnswered = false;
                const qId = question.id;
                let timeSpentForEachQuestion = timeSpent[qId] || null;
                if(timeSpentForEachQuestion) timeSpentForEachQuestion = timeSpentForEachQuestion / 1000;

                answers.map(answer => {
                  if (question.id === answer.id) {
                    isAnswered = true;
                    userSelectedAnswers.push({
                        ...answer, 
                        question_code: question.question_code, 
                        spentTime: timeSpentForEachQuestion,
                        time_spent: timeSpentForEachQuestion || 0
                    });
                    return;
                  }
                })         
            //    set null for unattempted questions
            if (!isAnswered) {
                const notAnswered = {
                    id: question.id,
                    answer_option: null,
                    question_code: question.question_code,
                    status: 0,
                    spentTime: timeSpentForEachQuestion,
                    time_spent: timeSpentForEachQuestion || 0
                }
                userSelectedAnswers.push(notAnswered);
            }
        })
        }else{
            dispatch(dispatchErrorSubmitTest({message: 'something went wrong...'}));
        }
        const userSubmitData = {
          test_id: _testId,
          mock_test_id: _testId,
          material_test_id: _testId,
        //   user_id: 10,
          questions: userSelectedAnswers,
          user_answers: userSelectedAnswers,
          location: location ? JSON.stringify(location) : 0
        }    

    dispatch(dispatchRequestSubmitTest(userSubmitData));
   
    getUserToken()
        .then(authKey => {
            return axios({
                method: 'POST',
                url: `${baseUrl}/api/${endPoint}`,
                data: userSubmitData,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            })
            .then(({ data }) => {                
                dispatch(dispatchReceivedSubmitTest(data));
            })
        })
        .catch(e => {
            dispatch(dispatchErrorSubmitTest(e.response));
        })
}
